module.exports = __webpack_public_path__ + "bcd4a68b019e956c70d3695f138be09f.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/left_hand/shield.png
// module id = 2433
// module chunks = 0